import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import ArrowWhite from "@/assets/img/arrow-white.svg";
import NewProductCard from "../NewProductCard/NewProductCard";
import styled from "styled-components";

SwiperCore.use([Navigation, Autoplay]);

interface Props {
  context?: "";
  title: string;
  data: any;
  slug: string;
}

export default function NewProduct({ title, context, data, slug }: Props) {
  return (
    <Wrapper>
      <div className="new-products">
        <div className="news-product-header">
          <div className="banner">
            <h2>
              {title}
              <p>{context}</p>
            </h2>
          </div>
        </div>

        <div className="container">
          <Swiper
            id="daily"
            tag="section"
            wrapperTag="div"
            navigation
            spaceBetween={16}
            draggable="true"
            autoplay={false}
            slidesPerView={4}
            breakpoints={{
              // when window width is >= 640px
              320: {
                slidesPerView: 1,
                spaceBetween: 8,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 16,
              },
              767: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              1199: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
            }}
          >
            {data.data.map((item: any, index: number) => (
              <SwiperSlide key={`${item.id} - ${index}`}>
                <NewProductCard
                  data={item}
                  md=""
                  slug={slug + `/${item.slug}`}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  #daily {
    width: 1292px !important;


    @media(max-width:1401px){
      width: 1124px !important;
      padding-left: 0 !important;
    }


    @media(max-width:1128px){
      width: 100% !important;
      padding-left: 0 !important;
    }

  }

  .new-products {
    margin-bottom: 7rem;

    .container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-gap: 0 16px;
      position: relative;

      .swiper {
        position: unset !important;

        @media screen and (max-width: 768px) {
          padding-left: 2rem;
        }

        .swiper-wrapper {
          padding-bottom: 5px;
        }

        .swiper-button-prev {
          background: radial-gradient(
              90.16% 143.01% at 15.32% 21.04%,
              rgba(165, 239, 255, 0.2) 0%,
              rgba(110, 191, 244, 0.0447917) 77.08%,
              rgba(70, 144, 213, 0) 100%
            ),
            url(${ArrowWhite.src});
          background-blend-mode: overlay, normal;
          backdrop-filter: blur(80px);
          border-radius: 16px;
          background-repeat: no-repeat;
          background-position: center;
          position: absolute;
          top: 50%;
          transform: scaleX(-1);
          left: -20px;
          width: 32px;
          height: 32px;

          //   display: block;
          //   background-image: url("../../assets//img/right.png");
          //   background-repeat: no-repeat;
          //   background-size: cover;
          //   border: 1px solid rgba(44, 20, 79, 0.1);
          //   border-radius: 50%;
          //   box-shadow: 0px 16px 48px rgba(28, 27, 107, 0.06);
          @media screen and (max-width: 1128px) {
            left: 0;
          }

          @media screen and (max-width: 768px) {
            display: none;
          }

          &.swiper-button-disabled {
            opacity: 0;
            background-image: url(${ArrowWhite.src});
            transform: scaleX(1);
          }

          &:after {
            display: none;
          }
        }

        .swiper-button-next {
          background: radial-gradient(
              90.16% 143.01% at 15.32% 21.04%,
              rgba(165, 239, 255, 0.2) 0%,
              rgba(110, 191, 244, 0.0447917) 77.08%,
              rgba(70, 144, 213, 0) 100%
            ),
            url(${ArrowWhite.src});
          background-repeat: no-repeat;
          background-position: center;
          background-blend-mode: overlay, normal;
          //backdrop-filter: blur(80px);
          border-radius: 16px;
          position: absolute;
          top: 50%;
          right: -20px;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;

          @media screen and (max-width: 1128px) {
            right: 0;
          }

          @media screen and (max-width: 768px) {
            display: none;
          }

          &.swiper-button-disabled {
            opacity: 0;
            /* background-image: url("../../assets/img/right.png"); */
            transform: scaleX(-1);
          }

          &:after {
            display: none;
          }
        }
      }
    }

    .news-product-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  @media screen and (max-width: 1199px) {
    .new-products {
      .container {
        grid-template-columns: repeat(1, 1fr) !important;
        max-width: 100%;

        .swiper-container {
          width: 100% !important;
        }
      }
    }
  }

  @media screen and (max-width: 767.9px) {
    .new-products {
      margin-bottom: 48px !important;
    }
  }
`;
